import en from "./locales/en";
import ru from "./locales/ru";
import uk from "./locales/uk";

export const resources = {
  en: {
    translation: en,
  },
  ru: {
    translation: ru,
    },
  uk: {
    translation: uk,
  },
} as const;
